export default function FaqSection() {
  const faqs = [
    {
      question: 'Czym jest usfansspreadsheet?',
      answer: 'usfansspreadsheet to nowoczesne narzędzie do zarządzania danymi w formie arkusza kalkulacyjnego, które łączy prostotę obsługi z zaawansowanymi funkcjami analitycznymi.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20wireless%20keyboard%20and%20mouse%20on%20white%20desk%2C%20monitor%20showing%20colorful%20charts%2C%20small%20succulent%20plant%2C%20bright%20natural%20window%20light%2C%20professional%20office%20photography%2C%20warm%20morning%20vibe&width=600&height=800&seq=faq-v2-01&orientation=portrait',
    },
    {
      question: 'Czy usfansspreadsheet jest bezpieczny?',
      answer: 'Tak, usfansspreadsheet wykorzystuje szyfrowanie SSL oraz zgodność z RODO, zapewniając pełną ochronę Twoich danych i prywatności.',
      image: 'https://readdy.ai/api/search-image?query=Metallic%20padlock%20on%20dark%20granite%20surface%2C%20warm%20golden%20key%20beside%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20security%20concept%20photography%2C%20rich%20dark%20and%20gold%20contrast%2C%20premium%20product%20style&width=600&height=800&seq=faq-v2-02&orientation=portrait',
    },
    {
      question: 'Jak usfansspreadsheet wypada w porównaniu z Excel?',
      answer: 'usfansspreadsheet oferuje większą prostotę i lepszą organizację danych w porównaniu z tradycyjnym Excel, zachowując przy tym wszystkie kluczowe funkcje analityczne.',
      image: 'https://readdy.ai/api/search-image?query=Split%20comparison%20of%20two%20smartphones%20side%20by%20side%20on%20marble%20surface%2C%20each%20showing%20different%20app%20interface%2C%20overhead%20shot%2C%20bright%20studio%20lighting%2C%20decision%20making%20concept%2C%20clean%20minimalist%20composition&width=600&height=800&seq=faq-v2-03&orientation=portrait',
    },
    {
      question: 'Czy usfansspreadsheet wymaga instalacji?',
      answer: 'Nie, usfansspreadsheet działa w przeglądarce internetowej i nie wymaga żadnej instalacji. Wystarczy dostęp do internetu, aby rozpocząć pracę.',
      image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20on%20cafe%20table%20with%20browser%20window%20visible%2C%20coffee%20cup%20and%20croissant%2C%20sunny%20window%20with%20city%20view%2C%20remote%20work%20lifestyle%2C%20bright%20natural%20lighting%2C%20relaxed%20atmosphere&width=600&height=800&seq=faq-v2-04&orientation=portrait',
    },
  ];

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-2">FAQ</p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
              Najczęściej zadawane pytania
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            Odpowiedzi na najczęstsze pytania dotyczące usfansspreadsheet
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {faqs.map((faq) => (
            <div
              key={faq.question}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:translate-y-[-2px] transition-all duration-300"
            >
              {/* Background Image */}
              <div className="w-full h-56 relative">
                <img
                  src={faq.image}
                  alt={faq.question}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                {/* FAQ Label */}
                <div className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full">
                  <span className="text-xs font-semibold text-foreground-800">FAQ</span>
                </div>

                {/* Text overlay at bottom */}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-semibold text-sm leading-snug mb-1">
                    {faq.question}
                  </p>
                  <p className="text-white/80 text-xs leading-relaxed line-clamp-2">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}